// The rail theme's brand mark. It is ORIGINAL: the saltire (St Andrew's Cross)
// is Scotland's national flag — a public symbol — drawn here as a plain bold
// cross. It deliberately does NOT reproduce any real rail operator's specific
// stylised logo; only the generic Scottish cross + the TPIAP wordmark.
const SANS = "-apple-system, 'Segoe UI', Roboto, system-ui, sans-serif";

export function RailLogo() {
  return (
    <svg className="rail-logo" viewBox="0 0 236 46" role="img" aria-label="TPIAP" xmlns="http://www.w3.org/2000/svg">
      {/* saltire mark — two crossing white bars on the navy header */}
      <line x1="9" y1="10" x2="41" y2="40" stroke="#ffffff" strokeWidth="9" />
      <line x1="41" y1="10" x2="9" y2="40" stroke="#ffffff" strokeWidth="9" />
      <text x="57" y="27" fontFamily={SANS} fontSize="23" fontWeight="800" fontStyle="italic" fill="#ffffff" letterSpacing="0.5">
        TPIAP
      </text>
      <text x="58" y="40" fontFamily={SANS} fontSize="8.5" fontWeight="600" fill="#cdd9f2" letterSpacing="1.4">
        SCOTLAND&rsquo;S SONG LEAGUE
      </text>
    </svg>
  );
}
